var _circle, _path, _path2, _path3, _circle2, _path4, _circle3, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 48,
    height: 48,
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30L32 20L44 30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30V42H40V30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 36l6 6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 35,
    r: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34l-4 6h4l-4 6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 48,
    r: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 43v2M32 51v2M27 48h2M35 48h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeService);
export default __webpack_public_path__ + "static/media/HomeService.27b1f89be64dbfeb918d773b2633e2ed.svg";
export { ForwardRef as ReactComponent };